import React from 'react';
import '../../../styles/app-marquee.css';

interface App {
  name: string;
  icon: string;
  iconWebp?: string;
}

const apps: App[] = [
  { 
    name: 'Telegram', 
    icon: '/icons/apps/optimized/Telegram_logo.svg'
  },
  { 
    name: 'Arc', 
    icon: '/icons/apps/optimized/arc.png',
    iconWebp: '/icons/apps/optimized/arc.webp'
  },
  { 
    name: 'Obsidian', 
    icon: '/icons/apps/optimized/obsidian.png',
    iconWebp: '/icons/apps/optimized/obsidian.webp'
  },
  { 
    name: 'Cursor', 
    icon: '/icons/apps/optimized/cursor.png',
    iconWebp: '/icons/apps/optimized/cursor.webp'
  },
  { 
    name: 'Perplexity', 
    icon: '/icons/apps/optimized/perplexity.png',
    iconWebp: '/icons/apps/optimized/perplexity.webp'
  },
  { 
    name: 'Claude', 
    icon: '/icons/apps/optimized/claude.png',
    iconWebp: '/icons/apps/optimized/claude.webp'
  },
  { 
    name: 'DeepSeek', 
    icon: '/icons/apps/optimized/deepseek.png',
    iconWebp: '/icons/apps/optimized/deepseek.webp'
  },
  { 
    name: 'Notion', 
    icon: '/icons/apps/optimized/notion.png',
    iconWebp: '/icons/apps/optimized/notion.webp'
  },
  { 
    name: 'Windsurf', 
    icon: '/icons/apps/optimized/windsurf.svg'
  },
  { 
    name: 'Superhuman', 
    icon: '/icons/apps/optimized/superhuman.png',
    iconWebp: '/icons/apps/optimized/superhuman.webp'
  },
  { 
    name: 'Gmail', 
    icon: '/icons/apps/optimized/gmail.svg'
  },
  { 
    name: 'Mail', 
    icon: '/icons/apps/optimized/apple-mail.png',
    iconWebp: '/icons/apps/optimized/apple-mail.webp'
  },
  { 
    name: 'Google Docs', 
    icon: '/icons/apps/optimized/google-docs.svg'
  },
  { 
    name: 'Slack', 
    icon: '/icons/apps/optimized/slack.svg'
  },
  { 
    name: 'WhatsApp', 
    icon: '/icons/apps/optimized/whatsapp.svg'
  },
  { 
    name: 'Signal', 
    icon: '/icons/apps/optimized/signal.svg'
  },
  { 
    name: 'Notes', 
    icon: '/icons/apps/optimized/notes.png',
    iconWebp: '/icons/apps/optimized/notes.webp'
  }
];

const AppTile: React.FC<{ app: App }> = ({ app }) => (
  <div className="app-card group">
    <div className="app-card-iconFrame">
      {app.iconWebp ? (
        <picture>
          <source srcSet={app.iconWebp} type="image/webp" />
          <img
            src={app.icon}
            alt={`${app.name} icon`}
            width={64}
            height={64}
            loading="lazy"
            className="app-card-icon"
          />
        </picture>
      ) : (
        <img
          src={app.icon}
          alt={`${app.name} icon`}
          width={64}
          height={64}
          loading="lazy"
          className="app-card-icon"
        />
      )}
    </div>
    <span className="app-card-label">{app.name}</span>
  </div>
);

const AppMarqueeTrack: React.FC<{ ariaHidden?: boolean }> = ({ ariaHidden = false }) => (
  <div className="app-marquee-track-inner" aria-hidden={ariaHidden}>
    {apps.map((app) => (
      <AppTile key={`${ariaHidden ? 'clone' : 'main'}-${app.name}`} app={app} />
    ))}
  </div>
);

const AppMarquee: React.FC = () => {
  return (
    <div className="w-full overflow-hidden">
      <div className="app-marquee-viewport relative w-full">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[var(--vi-bg-page)] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[var(--vi-bg-page)] to-transparent z-10 pointer-events-none" />
        
        <div className="app-marquee-trackShell">
          <div className="app-marquee-track app-marquee-track--primary">
            <AppMarqueeTrack />
          </div>
          <div className="app-marquee-track app-marquee-track--secondary">
            <AppMarqueeTrack ariaHidden />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppMarquee; 
